import { FALSE, TRUE } from "node-sass";
import {
  REGISTER_USER_VALIDATION,
  GET_USER_CURRENT_LOCATION_FAIL,
  GET_USER_CURRENT_LOCATION_REQUEST,
  GET_USER_CURRENT_LOCATION_SUCCESS,
  VERFIY_USER_REQUEST,
  VERFIY_USER_SUCCESS,
  VERFIY_USER_FAIL,
  GET_CALL_FAIL,
  POST_EVENT_REGISTRATION,
  POST_EVENT_REGISTRATION_SUCCESS,
  POST_EVENT_REGISTRATION_FAIL,
  GET_CALL_REQUEST,
  GET_CALL_RESET,
  GET_CALL_SUCCESS,
  ADD_FEEDBACK_FAIL,
  GET_STATE_REQUEST,
  GET_STATE_SUCCESS,
  GET_STATE_ERROR,
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILS,
  ADD_FEEDBACK_SUCCESS,
  GET_IMG_PACKAGES_FAIL,
  GET_IMAGINE_TESTIMONIALS_REQUEST,
  GET_IMAGINE_TESTIMONIALS_FAIL,
  GET_IMAGINE_TESTIMONIALS_SUCCESS,
  GET_IMG_PACKAGES_SUCCESS,
  GET_IMG_PACKAGES_REQUEST,
  ADD_FEEDBACK_REQUEST,
  GET_CITIES_FAIL,
  GET_CITIES_REQUEST,
  GET_CITIES_SUCCESS,
  GET_PACKAGES_FAIL,
  GET_PACKAGES_REQUEST,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGE_DETAILS_FAIL,
  GET_PACKAGE_DETAILS_REQUEST,
  GET_PACKAGE_DETAILS_RESET,
  GET_PACKAGE_DETAILS_SUCCESS,
  GET_SERVICES_FAIL,
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  GET_SERVICE_DETAILS_FAIL,
  GET_SERVICE_DETAILS_REQUEST,
  GET_SERVICE_DETAILS_SUCCESS,
  GET_USER_LOCATION_FAIL,
  GET_USER_LOCATION_REQUEST,
  GET_USER_LOCATION_SUCCESS,
  LOGIN_OTP_ERROR,
  LOGIN_OTP_SUCCESS,
  LOGIN_OTP_REQUEST,
  OTP_VERIFICATION_REQUEST,
  OTP_VERIFICATION_SUCCESS,
  OTP_VERIFICATION_ERROR,
  REGISTER_USER_FAIL,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  GET_CITY_FAIL,
  GET_CITY_REQUEST,
  GET_CITY_SUCCESS,
  SET_CITY_SUCCESS,
  SET_CITY_FAIL,
  CLEAR_CITY_FAIL,
  SET_SEARCH_SUCCESS,
  SET_SEARCH_FAIL,
  SET_SEARCH_RESET,
  GET_CUSTOMER_BOOKING_FAIL,
  GET_CUSTOMER_BOOKING_REQUEST,
  GET_CUSTOMER_BOOKING_SUCCESS,
  GET_REPORT_REQUEST,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_BLOG_REQUEST,
  GET_BLOG_SUCCESS,
  GET_BLOG_FAIL,
  GET_CUSTOMER_DASHBOARD_REQUEST,
  GET_CUSTOMER_DASHBOARD_SUCCESS,
  GET_CUSTOMER_DASHBOARD_FAIL,
  GET_TESTIMONIALS_REQUEST,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAIL,
  GET_BLOGS_REQUEST,
  GET_BLOGS_SUCCESS,
  GET_BLOGS_FAIL,
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_ERROR,
  GET_ALL_PACKAGES_REQUEST,
  GET_ALL_PACKAGES_SUCCESS,
  GET_ALL_PACKAGES_FAIL,
  GET_ALL_PACKAGE_DETAILS_RESET,
  GET_DIRECT_REPORT_REQUEST,
  GET_DIRECT_REPORT_SUCCESS,
  GET_DIRECT_REPORT_FAIL,
  SEND_PROFILE_DATA,
  SEND_PROFILE_DATA_SUCCESS,
  SEND_PROFILE_DATA_ERROR,
  RESET_FEDBACK,
  GET_JOB_REQUEST,
  GET_JOB_REQUEST_SUCCESS,
  GET_JOB_REQUEST_FAIL,
  SMS_VERIFICATION_CANCEL,
  SMS_VERIFICATION_CANCEL_SUCCESS,
  SMS_VERIFICATION_CANCEL_ERROR,
  SMS_VERIFICATION_CONFIRM,
  SMS_VERIFICATION_CONFIRM_SUCCESS,
  SMS_VERIFICATION_CONFIRM_ERROR,
  VIEW_BOOKING,
  VIEW_BOOKING_SUCCESS,
  VIEW_BOOKING_ERROR,
  UPLOAD_PRESCRIPTION,
  UPLOAD_PRESCRIPTION_SUCCESS,
  UPLOAD_PRESCRIPTION_ERROR,
  LOGIN_OTP_RESPONSE_CLEAR,
  USERLAND_MARK,
  USERLAND_MARK_SUCCESS,
  USERLAND_MARK_ERROR,
  USER_ERROR,
  GET_PACKAGE_CATEGORY_REQUEST,
  GET_PACKAGE_CATEGORY_SUCCESS,
  GET_PACKAGE_CATEGORY_FAIL,
  NEWS_LETTER_REQUEST,
  NEWS_LETTER_SUCCESS,
  NEWS_LETTER_ERRROR,
  UNSUBSCRIEBE_REQUEST,
  UNSUBSCRIEBE_REQUEST_SUCCESS,
  UNSUBSCRIEBE_REQUEST_ERROR,
  GET_CENTER_REQUEST,
  GET_CENTER_SUCCESS,
  GET_CENTER_FAIL,
  GET_CENTER_COLLECTION_REQUEST,
  GET_CENTER_COLLECTION_SUCCESS,
  GET_CENTER_COLLECTION_FAIL,
  LAB_PAGINATION_COLLECTION_FAIL,
  LAB_PAGINATION_REQUEST_SUCCESS,
  LAB_PAGINATION_REQUEST,
  CAREER_PAGINATION_COLLECTION_FAIL,
  CAREER_PAGINATION_REQUEST_SUCCESS,
  CAREER_PAGINATION_REQUEST,
  PAGINATION_REQUEST,
  PAGINATION_REQUEST_SUCCESS,
  PAGINATION_COLLECTION_FAIL,
  GET_FAMILY_FRIENDS_DATA_REQUEST,
  POST_FEANCHISE_FORM_REQUEST,
  POST_FEANCHISE_FORM_SUCCESS,
  POST_FEANCHISE_FORM_ERROR,
  GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
  GET_FAMILY_FRIENDS_DATA_FAIL,
  POST_FAMILY_FRIENDS_DATA_REQUEST,
  POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
  POST_FAMILY_FRIENDS_DATA_FAIL,
  GET_ALL_ADDRESS_REQUEST,
  GET_ALL_ADDRESS_REQUEST_SUCCESS,
  GET_ALL_ADDRESS_REQUEST_FAIL,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_REQUEST_SUCCESS,
  CREATE_ADDRESS_REQUEST_FAIL,
  EDIT_ADDRESS_REQUEST,
  EDIT_ADDRESS_REQUEST_SUCCESS,
  EDIT_ADDRESS_REQUEST_FAIL,
  GET_REPORT_REQUEST_USER,
  GET_REPORT_SUCCESS_USER,
  GET_REPORT_ERROR_USER,
  GET_CART_REQUEST,
  GET_CART_ERROR,
  GET_CART_SUCCESS,
  GET_CARRERDATA,
  GET_CARRERDATA_SUCCESS,
  GET_CARRERDATA_FAIL,
  DELETE_CART_ERROR,
  DELETE_CART_SUCCESS,
  DELETE_CART_REQUEST,
  DELETE_MULTI_ITEMS_CART_REQUEST,
  DELETE_MULTI_ITEMS_CART_SUCCESS,
  DELETE_MULTI_ITEMS_CART_ERROR,
  POST_CART_SUCCESS,
  POST_CART_REQUEST,
  GET_TEST_PARAMETER,
  GET_TEST_PARAMETER_SUCCESS,
  GET_TEST_PARAMETER_FAIL,
  GET_PINCODE_REQUEST,
  GET_PINCODE_SUCCESS,
  GET_PINCODE_ERROR,
  POST_ADDRESS_REQUEST,
  POST_ADDRESS_REQUEST_SUCCESS,
  POST_ADDRESS_FAIL,
  DELETE_ADDREESS_REQUEST,
  DELETE_ADDREESS_FAIL,
  CREATE_BOOKING_REQUEST,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_ERROR,
  EMPTY_REDUCER,
  EMPTY_CART_REQUEST,
  EMPTY_CART_SUCCESS,
  EMPTY_CART_FAIL,
  EPMTY_CART_OBJECT,
  EPMTY_REPORT_OJECT,
  SELECT_SLOT,
  GET_ALL_IMG_PACKAGES_REQUEST,
  GET_ALL_IMG_PACKAGES_SUCCESS,
  GET_ALL_IMG_PACKAGES_FAIL,
  GET_ADDRESS_IMG_PACKAGES_REQUEST,
  GET_ADDRESS_IMG_PACKAGES_SUCCESS,
  GET_ADDRESS_IMG_PACKAGES_FAIL,
  GET_COUPON_CODE_REQUEST,
  GET_COUPON_CODE_SUCCESS,
  GET_COUPON_CODE_ERROR,
  SET_ADDON_FALSE,
  SET_ADDON_TRUE,
  GET_REDCASH,
  GET_REDCASH_SUCCESS,
  GET_REDCASH_FAIL,
  GET_REDCASH_DETAILS,
  GET_REDCASH_DETAILS_SUCCESS,
  GET_REDCASH_DETAILS_FAIL,
  SET_CENTERADDRESS_SUCCESS,
  SET_CENTERADDRESS_FAIL,
  CLEAR_CENTERADDRESS,
  SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS,
  GET_IMG_TIME_SLOT_REQUEST,
  GET_IMG_TIME_SLOT_SUCCESS,
  GET_IMG_TIME_SLOT_ERROR,
  GET_DETAILS_IMG_PACKAGES_REQUEST,
  GET_DETAILS_IMG_PACKAGES_SUCCESS,
  GET_DETAILS_IMG_PACKAGES_FAIL,
  GET_DETAILS_IMG_PACKAGES_RESET,
  GET_MAP_MY_INDIA_ACCESS_TOKEN,
  GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS,
  GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL,
  GET_CITY_MAIN_REQUEST,
  GET_CITY_MAIN_SUCCESS,
  GET_CITY_MAIN_FAIL,
  SET_ISLOGOUT_SUCCESS,
  SET_ISLOGOUT_FAIL,
  GET_PRESCRIPTION_DATA_REQUEST,
  GET_PRESCRIPTION_DATA_SUCCESS,
  GET_PRESCRIPTION_DATA_FAIL,
  GET_FAMILY_CART_DATA_REQUEST,
  GET_FAMILY_CART_DATA_SUCCESS,
  GET_FAMILY_CART_DATA_FAIL,
  GET_CARRER_DATA_JOB_POSTING,
  GET_CARRER_DATA_JOB_POSTING_SUCCESS,
  GET_CARRER_DATA_JOB_POSTING_FAIL
} from "./Constants";

export const smsConfirm = (state = { smsConfStatus: {} }, action) => {
  switch (action.type) {
    case SMS_VERIFICATION_CONFIRM:
      return {
        loading: true,
        smsConfStatus: {},
      };
    case SMS_VERIFICATION_CONFIRM_SUCCESS:
      return {
        loading: false,
        smsConfStatus: action.payload,
      };
    case SMS_VERIFICATION_CONFIRM_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getCareerDataReducer = (state = { career_data: {} }, action) => {
  switch (action.type) {
    case GET_CARRERDATA:
      return {
        loading: true,
        career_data: {},
      };
    case GET_CARRERDATA_SUCCESS:
      return {
        loading: false,
        career_data: action.payload,
      };
    case GET_CARRERDATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const smsCancel = (state = { smsCanlStatus: {} }, action) => {
  switch (action.type) {
    case SMS_VERIFICATION_CANCEL:
      return {
        loading: true,
        smsCanlStatus: {},
      };
    case SMS_VERIFICATION_CANCEL_SUCCESS:
      return {
        loading: false,
        smsCanlStatus: action.payload,
      };
    case SMS_VERIFICATION_CANCEL_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const smsViewBooking = (state = { smsViewData: {} }, action) => {
  switch (action.type) {
    case VIEW_BOOKING:
      return {
        loading: true,
        smsViewData: {},
      };
    case VIEW_BOOKING_SUCCESS:
      return {
        loading: false,
        smsViewData: action.payload,
      };
    case VIEW_BOOKING_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getPackagesReducer = (state = { packages: {} }, action) => {
  switch (action.type) {
    case GET_PACKAGES_REQUEST:
      return {
        loading: true,
        packages: {},
      };
    case GET_PACKAGES_SUCCESS:
      return {
        loading: false,
        packages: action.payload,
      };
    case GET_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getRedcashDetailsReducer = (
  state = { redcash_details: {} },
  action
) => {
  switch (action.type) {
    case GET_REDCASH_DETAILS:
      return {
        loading: true,
        redcash_deails: {},
      };
    case GET_REDCASH_DETAILS_SUCCESS:
      return {
        loading: false,
        redcash_details: action.payload,
      };
    case GET_REDCASH_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export const getImgPackagesReducer = (
  state = { ImgPackages: [], ImgPackagesPageNation: [] },
  action
) => {
  switch (action.type) {
    case GET_ALL_IMG_PACKAGES_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_IMG_PACKAGES_SUCCESS:
      return {
        loading: false,
        ImgPackages: action.payload.results,
        ImgPackagesPageNation: action.payload,
      };
    case GET_ALL_IMG_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const setLogoutReducer = (state = { isLogout: "" }, action) => {
  switch (action.type) {
    case SET_ISLOGOUT_SUCCESS:
      return {
        isLogout: action.payload,
      };
    case SET_ISLOGOUT_FAIL:
      return {
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export const ImgPackagesReducer = (state = { ImgPackages: [] }, action) => {
  switch (action.type) {
    case GET_IMG_PACKAGES_REQUEST:
      return {
        loading: true,
      };
    case GET_IMG_PACKAGES_SUCCESS:
      return {
        loading: false,
        ImgPackages: action.payload,
      };
    case GET_IMG_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getImgPackagesAddressReducer = (
  state = { ImgPackagesAddress: [] },
  action
) => {
  switch (action.type) {
    case GET_ADDRESS_IMG_PACKAGES_REQUEST:
      return {
        loading: true,
      };
    case GET_ADDRESS_IMG_PACKAGES_SUCCESS:
      return {
        loading: false,
        ImgPackagesAddress: action.payload,
      };
    case SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS:
      return {
        ImgPackagesAddress: [],
      };
    case GET_ADDRESS_IMG_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getRedcashReducer = (state = { redcash: {} }, action) => {
  switch (action.type) {
    case GET_REDCASH:
      return {
        loading: true,
        redcash: {},
      };
    case GET_REDCASH_SUCCESS:
      return {
        loading: false,
        redcash: action.payload,
      };
    case GET_REDCASH_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getPackParamsReducer = (state = { testParam: {} }, action) => {
  switch (action.type) {
    case GET_TEST_PARAMETER:
      return {
        loading: true,
        testParam: {},
      };
    case GET_TEST_PARAMETER_SUCCESS:
      return {
        loading: false,
        testParam: action.payload,
      };
    case GET_TEST_PARAMETER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getPackagesCategoryReducer = (
  state = { packages_category: {} },
  action
) => {
  switch (action.type) {
    case GET_PACKAGE_CATEGORY_REQUEST:
      return {
        loading: true,
        packages_category: {},
      };
    case GET_PACKAGE_CATEGORY_SUCCESS:
      return {
        loading: false,
        packages_category: action.payload,
      };
    case GET_PACKAGE_CATEGORY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getBlogReducer = (state = { packages: {} }, action) => {
  switch (action.type) {
    case GET_BLOG_REQUEST:
      return {
        loading: true,
        packages: {},
      };
    case GET_BLOG_SUCCESS:
      return {
        loading: false,
        packages: action.payload,
      };
    case GET_BLOG_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const AddonSetter = (state = { Addon: false }, action) => {
  switch (action.type) {
    case SET_ADDON_TRUE:
      return {
        Addon: true,
      };
    case SET_ADDON_FALSE:
      return {
        Addon: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getDirectReportReducer = (
  state = { direct_reports: {} },
  action
) => {
  switch (action.type) {
    case GET_DIRECT_REPORT_REQUEST:
      return {
        loading: true,
        direct_reports: {},
      };
    case GET_DIRECT_REPORT_SUCCESS:
      return {
        loading: false,
        direct_reports: action.payload,
      };
    case GET_DIRECT_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getCustomerDashboardReducer = (
  state = { packages: {} },
  action
) => {
  switch (action.type) {
    case GET_CUSTOMER_DASHBOARD_REQUEST:
      return {
        loading: true,
        packages: {},
      };
    case GET_CUSTOMER_DASHBOARD_SUCCESS:
      return {
        loading: false,
        packages: action.payload,
      };
    case GET_CUSTOMER_DASHBOARD_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getPackageDetailsReducer = (
  state = { packDetail: {} },
  action
) => {
  switch (action.type) {
    case GET_PACKAGE_DETAILS_REQUEST:
      return {
        loading: true,
        packDetail: {},
      };
    case GET_PACKAGE_DETAILS_SUCCESS:
      return {
        loading: false,
        packDetail: action.payload,
      };
    case GET_PACKAGE_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_PACKAGE_DETAILS_RESET:
      return {
        packDetail: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export const getAllPackageDetailsReducer = (
  state = { AllpackDetail: {} },
  action
) => {
  switch (action.type) {
    case GET_ALL_PACKAGES_REQUEST:
      return {
        loading: true,
        AllpackDetail: {},
      };
    case GET_ALL_PACKAGES_SUCCESS:
      return {
        loading: false,
        AllpackDetail: action.payload,
      };
    case GET_ALL_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_PACKAGE_DETAILS_RESET:
      return {
        AllpackDetail: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export const userLocationReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_LOCATION_REQUEST:
      return {
        loading: true,
      };
    case GET_USER_LOCATION_SUCCESS:
      return {
        loading: false,
        location: action.payload,
      };
    case GET_USER_LOCATION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const serviceDetailsReducer = (state = { service: {} }, action) => {
  switch (action.type) {
    case GET_SERVICE_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case GET_SERVICE_DETAILS_SUCCESS:
      return {
        loading: false,
        service: action.payload,
      };
    case GET_SERVICE_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const servicesReducer = (state = { services: {} }, action) => {
  switch (action.type) {
    case GET_SERVICES_REQUEST:
      return {
        loading: true,
      };
    case GET_SERVICES_SUCCESS:
      return {
        loading: false,
        services: action.payload,
      };
    case GET_SERVICES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getCallReducer = (state = { success: false }, action) => {
  switch (action.type) {
    case GET_CALL_REQUEST:
      return {
        loading: true,
        success: false,
      };
    case GET_CALL_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case GET_CALL_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CALL_RESET:
      return {};
    default:
      return {
        ...state,
      };
  }
};

export const cityListReducer = (state = { cities: [] }, action) => {
  switch (action.type) {
    case GET_CITIES_REQUEST:
      return {
        loading: true,
      };
    case GET_CITIES_SUCCESS:
      return {
        loading: false,
        cities: action.payload,
      };
    case GET_CITIES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export const navCityListReducer = (state = { navCities: {} }, action) => {
  switch (action.type) {
    case GET_CITY_REQUEST:
      return {
        loading: true,
      };
    case GET_CITY_SUCCESS:
      return {
        loading: false,
        navCities: action.payload,
      };
    case GET_CITY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const LpCityListReducer = (state = { LpCityList: {} }, action) => {
  switch (action.type) {
    case GET_CITY_MAIN_REQUEST:
      return {
        loading: true,
      };
    case GET_CITY_MAIN_SUCCESS:
      return {
        loading: false,
        LpCityList: action.payload,
      };
    case GET_CITY_MAIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const otpLoginReducer = (state = { otpLoginResponse: {} }, action) => {
  switch (action.type) {
    case LOGIN_OTP_REQUEST:
      return {
        loading: true,
      };
    case LOGIN_OTP_SUCCESS:
      return {
        loading: false,
        otploginResponse: action.payload,
      };
    case LOGIN_OTP_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const otpVerificationReducer = (
  state = { otpVerificationResponse: {} },
  action
) => {
  switch (action.type) {
    case OTP_VERIFICATION_REQUEST:
      return {
        loading: true,
      };
    case OTP_VERIFICATION_SUCCESS:
      return {
        loading: false,
        otpVerificationResponse: action.payload,
      };
    case OTP_VERIFICATION_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    case LOGIN_OTP_RESPONSE_CLEAR:
      return {
        loading: true,
        otpVerificationResponse: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export const registerUserReducer = (
  state = { registerUserResponse: {} },
  action
) => {
  switch (action.type) {
    case REGISTER_USER_REQUEST:
      return {
        loading: true,
      };
    case REGISTER_USER_SUCCESS:
      return {
        loading: false,
        registerUserResponse: action.payload,
      };

    case REGISTER_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const setCityReducer = (state = { citySelect: "" }, action) => {
  switch (action.type) {
    case SET_CITY_SUCCESS:
      return {
        citySelect: action.payload,
      };
    case SET_CITY_FAIL:
      return {
        error: action.payload,
      };
    case CLEAR_CITY_FAIL:
      return {
        citySelect: "",
      };
    default:
      return {
        ...state,
      };
  }
};

export const setMainSearchReducer = (state = { mainsearch: "" }, action) => {
  switch (action.type) {
    case SET_SEARCH_SUCCESS:
      return {
        mainsearch: action.payload,
      };
    case SET_SEARCH_FAIL:
      return {
        error: action.payload,
      };
    case SET_SEARCH_RESET:
      return {
        mainsearch: "",
      };
    default:
      return {
        ...state,
      };
  }
};

export const customerDetailBookingReducer = (
  state = { customerDetailResponse: {} },
  action
) => {
  switch (action.type) {
    case GET_CUSTOMER_BOOKING_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_BOOKING_SUCCESS:
      return {
        loading: false,
        customerDetailResponse: action.payload,
      };
    case GET_CUSTOMER_BOOKING_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const downloadReportReducer = (
  state = { downloadReportResponse: {} },
  action
) => {
  switch (action.type) {
    case GET_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_REPORT_SUCCESS:
      return {
        loading: false,
        downloadReport: action.payload,
      };
    case GET_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const testimonialsReducer = (state = { testimonials: [] }, action) => {
  switch (action.type) {
    case GET_TESTIMONIALS_REQUEST:
      return {
        loading: true,
      };
    case GET_TESTIMONIALS_SUCCESS:
      return {
        loading: false,
        testimonials: action.payload,
      };
    case GET_TESTIMONIALS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const ImaginetestimonialsReducer = (
  state = { testimonials: [] },
  action
) => {
  switch (action.type) {
    case GET_IMAGINE_TESTIMONIALS_REQUEST:
      return {
        loading: true,
      };
    case GET_IMAGINE_TESTIMONIALS_SUCCESS:
      return {
        loading: false,
        testimonials: action.payload,
      };
    case GET_IMG_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const BlogsReducer = (state = { blogs: {} }, action) => {
  switch (action.type) {
    case GET_BLOGS_REQUEST:
      return {
        loading: true,
      };
    case GET_BLOGS_SUCCESS:
      return {
        loading: false,
        blogs: action.payload,
      };
    case GET_BLOGS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

{
  /** GET_JOB_REQUEST,  
  GET_JOB_REQUEST_SUCCESS ,
  GET_JOB_REQUEST_FAIL  */
}

export const jobDataReducer = (state = { jobs: {} }, action) => {
  switch (action.type) {
    case GET_JOB_REQUEST:
      return {
        loading: true,
      };
    case GET_JOB_REQUEST_SUCCESS:
      return {
        loading: false,
        jobs: action.payload,
      };
    case GET_JOB_REQUEST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};
export const EditProfileReducer = (
  state = { otpLoginResponse: {} },
  action
) => {
  switch (action.type) {
    case EDIT_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case EDIT_PROFILE_SUCCESS:
      return {
        loading: false,
        otploginResponse: action.payload,
      };
    case EDIT_PROFILE_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const careerFormReducer = (state = { careerForm: {} }, action) => {
  switch (action.type) {
    case SEND_PROFILE_DATA:
      return {
        loading: true,
      };

    case SEND_PROFILE_DATA_SUCCESS:
      return {
        loading: false,
        careerForm: action.payload,
      };

    case SEND_PROFILE_DATA_ERROR:
      return {
        loading: false,
        careerForm: action.payload,
      };
    default: {
      return {
        ...state,
      };
    }
  }
};

export const uploadPrescriptionReducer = (
  state = { uploadPresciption: {} },
  action
) => {
  switch (action.type) {
    case UPLOAD_PRESCRIPTION:
      return {
        loading: true,
      };

    case UPLOAD_PRESCRIPTION_SUCCESS:
      return {
        loading: false,
        uploadPresciption: action.payload,
      };

    case UPLOAD_PRESCRIPTION_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const newsLetterReducer = (state = { newsletterDetail: {} }, action) => {
  switch (action.type) {
    case NEWS_LETTER_REQUEST:
      return {
        loading: true,
      };
    case NEWS_LETTER_SUCCESS:
      return {
        loading: false,
        newsletterDetail: action.payload,
      };
    case NEWS_LETTER_ERRROR:
      return {
        loadig: false,
        error: action.payload,
      };
    default: {
      return { ...state };
    }
  }
};
export const landMarkReducer = (state = { landMarkDetails: {} }, action) => {
  switch (action.type) {
    case USERLAND_MARK:
      return {
        loading: true,
      };

    case USERLAND_MARK_SUCCESS: {
      return {
        loading: false,
        landMarkDetails: action.payload,
      };
    }

    case USERLAND_MARK_ERROR:
      return {
        loading: false,
        landMarkDetails: action.payload,
      };

    default:
      return { ...state };
  }
};

export const unsubReducer = (state = { unSubscribe: {} }, action) => {
  switch (action) {
    case UNSUBSCRIEBE_REQUEST:
      return {
        loading: true,
        unSubscribe: {},
      };
    case UNSUBSCRIEBE_REQUEST_SUCCESS:
      return {
        loading: false,
        unSubscribe: action.payload,
      };
    case UNSUBSCRIEBE_REQUEST_ERROR:
      return {
        loading: false,
        unSubscribe: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

//CENTER

export const centerAddressReducer = (
  state = { center: {}, loading: true },
  action
) => {
  switch (action.type) {
    case GET_CENTER_REQUEST:
      return {
        loading: true,
      };
    case GET_CENTER_SUCCESS:
      return {
        loading: false,
        center: action.payload,
      };
    case GET_CENTER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const paginationReducer = (
  state = { center: {}, loading: true },
  action
) => {
  switch (action.type) {
    case PAGINATION_REQUEST:
      return {
        loading: true,
      };
    case PAGINATION_REQUEST_SUCCESS:
      return {
        loading: false,
        paginated: action.payload,
      };
    case PAGINATION_COLLECTION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

//labPagination
export const labpaginationReducer = (
  state = { labPagination: {}, loading: true },
  action
) => {
  switch (action.type) {
    case LAB_PAGINATION_REQUEST:
      return {
        loading: true,
      };
    case LAB_PAGINATION_REQUEST_SUCCESS:
      return {
        loading: false,
        paginated: action.payload,
      };
    case LAB_PAGINATION_COLLECTION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

//careerPagination
export const careerpaginationReducer = (
  state = { careerPagination: {}, loading: true },
  action
) => {
  switch (action.type) {
    case CAREER_PAGINATION_REQUEST:
      return {
        loading: true,
      };
    case CAREER_PAGINATION_REQUEST_SUCCESS:
      return {
        loading: false,
        paginated: action.payload,
      };
    case CAREER_PAGINATION_COLLECTION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

// colection

export const collectionAddedCenter = (
  state = { collection: {}, loading: true },
  action
) => {
  switch (action.type) {
    // GET_CENTER_COLLECTION_REQUEST,GET_CENTER_COLLECTION_SUCCESS,GET_CENTER_COLLECTION_FAIL
    case GET_CENTER_COLLECTION_REQUEST:
      return {
        loading: true,
      };
    case GET_CENTER_COLLECTION_SUCCESS:
      return {
        loading: false,
        collection: action.payload,
      };
    case PAGINATION_COLLECTION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

// Get Data family and friends

export const familyFriendReducer = (
  state = { data: {}, loading: true },
  action
) => {
  switch (action.type) {
    case GET_FAMILY_FRIENDS_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
      };
    case GET_FAMILY_FRIENDS_DATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

// Post data family and friends

export const familyFriendPostReducer = (
  state = { data: {}, loading: true },
  action
) => {
  switch (action.type) {
    case POST_FAMILY_FRIENDS_DATA_REQUEST:
      return {
        loading: true,
      };
    case POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
      };
    case POST_FAMILY_FRIENDS_DATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

export const addressReducer = (
  state = { addresss: {}, loading: true },
  action
) => {
  switch (action.type) {
    case GET_ALL_ADDRESS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_ADDRESS_REQUEST_SUCCESS:
      return {
        loading: false,
        addresss: action.payload,
      };
    case GET_ALL_ADDRESS_REQUEST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return { ...state };
  }
};

export const registerAddressReducer = (
  state = { registerAddressResponse: {} },
  action
) => {
  switch (action.type) {
    case CREATE_ADDRESS_REQUEST:
      return {
        loading: true,
      };
    case CREATE_ADDRESS_REQUEST_SUCCESS:
      return {
        loading: false,
        registerAddressResponse: action.payload,
      };
    case CREATE_ADDRESS_REQUEST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const editAddressReducer = (
  state = { editAddressResponse: {} },
  action
) => {
  switch (action.type) {
    case EDIT_ADDRESS_REQUEST:
      return {
        loading: true,
      };
    case EDIT_ADDRESS_REQUEST_SUCCESS:
      return {
        loading: false,
        editAddressResponse: action.payload,
      };
    case EDIT_ADDRESS_REQUEST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const ReportReducer = (
  state = { report: {}, loading: true },
  action
) => {
  // console.log(action, "Here Reducer");
  switch (action.type) {
    case GET_REPORT_REQUEST_USER:
      return {
        loading: true,
      };
    case GET_REPORT_SUCCESS_USER:
      return {
        loading: false,
        report: action.payload,
      };
    case GET_REPORT_ERROR_USER:
      return {
        loading: false,
        error: action.payload,
      };

    case EPMTY_REPORT_OJECT:
      return {
        loading: false,
        report: "",
      };
    default:
      return {
        ...state,
      };
  }
};

export const CartReducer = (state = { cartDetails: {} }, action) => {
  switch (action.type) {
    case GET_CART_REQUEST:
      return {
        loading: true,
      };
    case GET_CART_SUCCESS:
      return {
        loading: false,
        cartDetails: action.payload,
      };
    case GET_CART_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    case SET_ISLOGOUT_SUCCESS:
      return {
        loading: false,
        cartDetails: {},
      };
    default:
      return {
        ...state,
      };
  }
};

//ADD TO CART REDUCER

export const addToCartReducer = (state = { cart: "" }, action) => {
  switch (action.type) {
    case POST_CART_REQUEST:
      return {
        loading: true,
      };
    case POST_CART_SUCCESS:
      return {
        loading: false,
        cart: action.payload,
      };
    case EPMTY_CART_OBJECT:
      return {
        loading: false,
        cart: "",
      };
    default:
      return {
        ...state,
      };
  }
};

//delete cart reducer
export const deleteCart = (state = { loading: true, response: {} }, action) => {
  switch (action.type) {
    case DELETE_CART_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CART_SUCCESS:
      return {
        loading: false,
        response: action.payload,
      };

    case DELETE_CART_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

//delete mulitple item cart reducer
export const deleteMulitItemsCart = (
  state = { loading: true, response: {} },
  action
) => {
  switch (action.type) {
    case DELETE_MULTI_ITEMS_CART_REQUEST:
      return {
        loading: true,
      };
    case DELETE_MULTI_ITEMS_CART_SUCCESS:
      return {
        loading: false,
        response: action.payload,
      };

    case DELETE_MULTI_ITEMS_CART_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

//area pincode reducer
export const areaPincodeReducer = (
  state = { loading: true, areaPincode: {}, error: {} },
  action
) => {
  switch (action.type) {
    case GET_PINCODE_REQUEST:
      return {
        loading: true,
      };
    case GET_PINCODE_SUCCESS:
      return {
        loading: false,
        areaPincode: action.payload,
      };

    case GET_PINCODE_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const newAddressReducer = (
  state = { loading: true, addressPost: {} },
  action
) => {
  switch (action.type) {
    case POST_ADDRESS_REQUEST:
      return {
        loading: true,
      };
    case POST_ADDRESS_REQUEST_SUCCESS:
      return {
        loading: false,
        addressPost: action.payload,
      };
    case POST_ADDRESS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

//delete address

export const deleteAddressReduccer = (
  state = { delete: {}, loading: true },
  action
) => {
  switch (action.type) {
    case DELETE_ADDREESS_REQUEST:
      return {
        loading: true,
      };

    case DELETE_CART_SUCCESS:
      return {
        loading: false,
        delete: action.payload,
      };
    case DELETE_ADDREESS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const CreateBookingReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_BOOKING_REQUEST:
      return {
        loading: true,
      };
    case CREATE_BOOKING_SUCCESS:
      return {
        loading: false,
        create: action.payload,
      };
    case CREATE_BOOKING_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    case EMPTY_REDUCER:
      return {
        loading: false,
        create: action.payload,
      };
    default:
      return { ...state };
  }
};

export const EmptycartReducer = (state = { refresh: {} }, action) => {
  switch (action.type) {
    case EMPTY_CART_REQUEST:
      return {
        loading: true,
      };
    case EMPTY_CART_SUCCESS:
      return {
        loading: false,
        state: action.payload,
      };
    case EMPTY_CART_FAIL:
      return {
        loading: false,
        state: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const SelectedSlot = (state = { selectedSlot: "" }, action) => {
  switch (action.type) {
    case SELECT_SLOT:
      return {
        state: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const getCouponCodeReducer = (
  state = { coupnCode: "", loading: true },
  action
) => {
  switch (action.type) {
    case GET_COUPON_CODE_REQUEST:
      return {
        loading: true,
      };

    case GET_COUPON_CODE_SUCCESS:
      return {
        loading: false,
        coupnCode: action.payload,
      };

    case GET_COUPON_CODE_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export const AddFeedbackReducer = (
  state = { status: {}, feedbackSent: false },
  action
) => {
  switch (action.type) {
    case ADD_FEEDBACK_REQUEST:
      return {
        feedbackSent: false,
      };
    case ADD_FEEDBACK_SUCCESS:
      return {
        feedbackSent: true,
        status: action.payload,
      };

    case RESET_FEDBACK:
      return {
        feedbackSent: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export const setImgCenterAddressReducer = (
  state = { CenterAddress: {} },
  action
) => {
  switch (action.type) {
    case SET_CENTERADDRESS_SUCCESS:
      return {
        CenterAddress: action.payload,
      };
    case SET_CENTERADDRESS_FAIL:
      return {
        error: action.payload,
      };
    case CLEAR_CENTERADDRESS:
      return {
        CenterAddress: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export const getImgTimeSlotReducer = (state = { ImgTimeSlot: [] }, action) => {
  switch (action.type) {
    case GET_IMG_TIME_SLOT_REQUEST:
      return {
        loading: true,
      };
    case GET_IMG_TIME_SLOT_SUCCESS:
      return {
        loading: false,
        ImgTimeSlot: action.payload,
      };
    case GET_IMG_TIME_SLOT_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getImgDetalReducer = (state = { ImgPackDetals: {} }, action) => {
  switch (action.type) {
    case GET_DETAILS_IMG_PACKAGES_REQUEST:
      return {
        loading: true,
      };
    case GET_DETAILS_IMG_PACKAGES_SUCCESS:
      return {
        loading: false,
        ImgPackDetals: action.payload,
      };
    case GET_DETAILS_IMG_PACKAGES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_DETAILS_IMG_PACKAGES_RESET:
      return {
        ImgPackDetals: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export const mapMyindiaToken = (state = { accesstoken: "" }, action) => {
  switch (action.type) {
    case GET_MAP_MY_INDIA_ACCESS_TOKEN:
      return {
        loading: true,
      };
    case GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS:
      return {
        loading: false,
        accesstoken: action.payload,
      };
    case GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getCurrentLocationReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_CURRENT_LOCATION_REQUEST:
      return {
        loading: true,
      };
    case GET_USER_CURRENT_LOCATION_SUCCESS:
      return {
        loading: false,
        location: action.payload,
      };

    case GET_USER_CURRENT_LOCATION_FAIL:
      return {
        loading: false,
        error: error,
      };

    default:
      return {
        ...state,
      };
  }
};

export const getEventReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_EVENTS:
      return {
        loading: true,
      };
    case GET_EVENTS_SUCCESS:
      return {
        loading: false,
        events: action.payload,
      };
    case GET_EVENTS_FAILS:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export const getStateReducer = (state = {}, action) => {
  // console.log("actiondata",action)
  switch (action.type) {
    case GET_STATE_REQUEST:
      return {
        loading: true,
      };

    case GET_STATE_SUCCESS:
      return {
        loading: false,
        dataState: action.payload,
      };

    case GET_STATE_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const postFrenchiseReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_FEANCHISE_FORM_REQUEST:
      return {
        loading: true,
      };
    case POST_FEANCHISE_FORM_SUCCESS:
      return {
        loading: false,
        postFrenchise: action.payload,
      };
    case POST_EVENT_REGISTRATION_FAIL:
      return {
        loading: false,
        errors: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export const VerfiyUserReducer = (state = {}, action) => {
  switch (action.type) {
    case VERFIY_USER_REQUEST:
      return {
        loading: true,
      };

    case VERFIY_USER_SUCCESS:
      return {
        loading: false,
        status: action.payload,
      };

    case VERFIY_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export const getPrescriptionDataReducer = (
  state = { PrescriptionDetails: {} },
  action
) => {
  switch (action.type) {
    case GET_PRESCRIPTION_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_PRESCRIPTION_DATA_SUCCESS:
      return {
        loading: false,
        PrescriptionDetails: action.payload,
      };
    case GET_PRESCRIPTION_DATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default: {
      return {
        ...state,
      };
    }
  }
};

export const getJobPostingCareerData = (state = { jobPostingList: [] }, action) => {
  switch (action.type) {
    case GET_CARRER_DATA_JOB_POSTING:
      return {
        loading: true,
        jobPostingList: [],
      };
    case GET_CARRER_DATA_JOB_POSTING_SUCCESS:
      return {
        loading: false,
        jobPostingList: action.payload,
      };
    case GET_CARRER_DATA_JOB_POSTING_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}

export const getFamilyCartDataReducer = (
  state = { familyCartData: [] },
  action
) => {
  switch (action.type) {
    case GET_FAMILY_CART_DATA_REQUEST:
      return {
        loadig: true
      }
    case GET_FAMILY_CART_DATA_SUCCESS:
      return {
        loadig: false,
        familyCartData: action.payload,
      }
    case GET_FAMILY_CART_DATA_FAIL:
      return {
        loadig: false,
        error: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}